// extracted by mini-css-extract-plugin
export var parcelRow = "_ui-0";